// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","510":"d14b2c90","872":"520c8229","998":"fc83e031"}[chunkId] + "-" + {"245":"b7879ccc72367fbb3b90","453":"dae32a54fc6f1c17c569","510":"92fe936c324ef713720d","872":"f3ec4fb8dc3296a01b75","998":"37e00b5bb5ad5437e4c4"}[chunkId] + ".js";
};